import React, {Component} from 'react';
import Carousel from '@homeaway/react-card-carousel';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Card from './Card';
import SectionTitle from '../SectionTitle/SectionTitle';
import {HomeRouteContext} from '../../utils/context';
import {removeFalsyValuesInArray} from '../../utils/utils';
import './CardCarousel.less';

class CardCarousel extends Component {
    state = {
        index: 0,
    };

    handlePrevNext = (e, newIndex) => {
        this.setState({index: newIndex});
    };

    render() {
        const {
            id,
            cards,
            isInArticle,
            isDevice,
            title,
            translations,
        } = this.props;
        const filteredCards = removeFalsyValuesInArray(cards);
        if (filteredCards.length < 2) {
            return null;
        }

        return (
            <section
                id={id}
                className={classNames('HubCardCarousel', {
                    'hub-section': !isInArticle,
                })}
            >
                {title && (
                    <SectionTitle title={title} isInArticle={isInArticle} />
                )}

                <HomeRouteContext.Consumer>
                    {(homeRoute) => (
                        <Carousel
                            breakpoints={{
                                820: 4,
                                540: 3,
                                0: 2,
                            }}
                            cardIndex={this.state.index}
                            onNextClick={this.handlePrevNext}
                            onPreviousClick={this.handlePrevNext}
                            nextLabel={translations.next || 'next'}
                            scrolling={isDevice}
                            previousLabel={translations.previous || 'previous'}
                            paging
                        >
                            {filteredCards.map((item, idx) => {
                                const url = item.link || homeRoute + item.path;
                                const title = item.title || item.name;
                                const content = item.subtitle || item.details;

                                return (
                                    <Card
                                        {...item}
                                        key={idx}
                                        link={url}
                                        title={title}
                                        content={content}
                                    />
                                );
                            })}
                        </Carousel>
                    )}
                </HomeRouteContext.Consumer>
            </section>
        );
    }
}

CardCarousel.propTypes = {
    isDevice: PropTypes.bool,
    title: PropTypes.string,
    cards: PropTypes.arrayOf(PropTypes.object),
    translations: PropTypes.shape({
        previous: PropTypes.string.isRequired,
        next: PropTypes.string.isRequired,
    }),
};

export default CardCarousel;
